'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponentsReactiveGrid = require('styled-components-reactive-grid');

var _decisivUiUtils = require('decisiv-ui-utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// this acts as our <th> element
var styles = function styles(_ref) {
  var theme = _ref.theme,
      flex = _ref.flex,
      minWidth = _ref.minWidth;
  return '\n  align-items: center;\n  color: ' + theme.colors.base.chrome500 + ';\n  display: flex;\n  flex: ' + flex + ';\n  font-size: ' + (0, _decisivUiUtils.px2rem)(12) + ';\n  font-weight: 400;\n  justify-content: flex-start;\n  min-width: ' + (0, _decisivUiUtils.px2rem)(minWidth) + ';\n';
};

var propTypes = {
  flex: _propTypes2.default.number.isRequired,
  minWidth: _propTypes2.default.number.isRequired
};

var defaultProps = {
  flex: 1,
  minWidth: 100
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      chrome500: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('Header', (0, _styledComponents2.default)(_styledComponentsReactiveGrid.Column), styles, {
  defaultProps: defaultProps,
  propTypes: propTypes,
  themePropTypes: themePropTypes
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/base-components/build/blocks/ListTable/Header.js
// module id = 1598
// module chunks = 2